import { SurveyType, SurveyScope } from 'client/common/types';

import { createLink } from 'client/common/utils/window';

interface GenSurveyStatisticsParams {
    slug: string;
    surveyType: SurveyType | undefined;
    isRelative?: boolean;
    surveyScope?: SurveyScope;
}

export function genSurveyLink({ slug, surveyType, isRelative }: GenSurveyStatisticsParams): string {
    let path: string;

    switch (surveyType) {
        case 'ux':
            path = `/ux/${slug}`;
            break;
        case 'creative':
            path = `/creative/${slug}`;
            break;
        case 'bordomatik':
            path = `/bordomatik/${slug}`;
            break;
        default:
            path = `/qs/${slug}`;
            break;
    }

    return createLink(path, isRelative);
}

export function genStatisticsLink({
    slug,
    surveyType,
    isRelative,
    surveyScope = SurveyScope.Yandex
}: GenSurveyStatisticsParams): string {
    let path;

    switch (surveyType) {
        case 'ux':
            path = `/ux/statistics/${slug}`;
            break;
        case 'creative':
            path = `/creative/statistics/${slug}`;
            break;
        case 'bordomatik':
            path = `/bordomatik/statistics/${slug}`;
            break;
        case 'videoBox':
        case 'videoBoxKZ':
        case 'createSegment':
        default:
            path = `/quicksurvey/statistics/${slug}`;
            break;
    }

    return createLink(path, isRelative, surveyScope);
}
